import {useEffect} from 'react'

/**
 *
 * @param callback callback to call after certain period of time
 * @param delay delay in milliseconds for each callback when depdenent value changes
 * @param dependencies depedenent values to check if callback should be called
 */
const useDebounce = (
  callback: () => void,
  delay: number,
  dependencies: any[] // eslint-disable-line @typescript-eslint/no-explicit-any
) => {
  useEffect(() => {
    const timeout = setTimeout(callback, delay)

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [...dependencies, delay]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useDebounce
